export default __webpack_public_path__ + "static/media/icon_webpush.0df561aa.jpg";